import BaseApi from "./BaseApi";

export default class Department extends BaseApi{
    construct() {}

    static async list(params) {
        let url = Department.getApiUrl() + "list";

        return Department.getAxiosInstance().get(url,{params: params});
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/client/departments/";
    }
}